<template src="./template.html"></template>
<style src="./style.css" scoped></style>

<script>

import { mapActions } from 'vuex';

export default {
  name: "v-tutorial-cenarios",
  data() {
    return {
      idInitial: 90,
      idFinal: 93,
      idCurrent: 90
    };
  },
  mounted() {
    this.firstLogin();
  },
  methods: {
    ...mapActions('usuario', ['salvarTutorialCenario']),
    firstLogin() {
      if (localStorage.getItem('tutorial_cenario') == '0') {
        this.salvarTutorialCenario(1);

        localStorage.setItem('tutorial_cenario', 1);

        return this.show();
      }
    },
    next() {
      return this.idCurrent == this.idFinal ? this.idCurrent : ++this.idCurrent;
    },
    prev() {
      return this.idCurrent == this.idInitial
        ? this.idCurrent
        : --this.idCurrent;
    },
    hide() {
      this.idCurrent = this.idInitial;
      this.$refs.modalTutorial.hide();
    },
    show() {
      this.$refs.modalTutorial.show();
    }
  }
};
</script>
